import { Breadcrumbs, BreadcrumbItem } from "@heroui/react";
import { Link } from "react-router-dom";
import ThemedText from "./ThemedText";

/**
 * PageHeader - Reusable page header with title and breadcrumbs
 *
 * @param {string} title - Page title
 * @param {Array} breadcrumbs - Array of breadcrumb items { label, href? }
 * @param {string} description - Optional description text below breadcrumbs
 */
const PageHeader = ({ title, breadcrumbs = [], description }) => {
    return (
        <div className="flex flex-col gap-1">
            <ThemedText size="xl" className="font-bold">
                {title}
            </ThemedText>
            {description && (
                <ThemedText
                    variant="secondary"
                    size="sm"
                    className="-mt-1 mb-0.5"
                >
                    {description}
                </ThemedText>
            )}
            {breadcrumbs.length > 0 && (
                <Breadcrumbs size="sm">
                    {breadcrumbs.map((item, index) => (
                        <BreadcrumbItem key={index}>
                            {item.href ? (
                                <Link to={item.href}>{item.label}</Link>
                            ) : (
                                item.label
                            )}
                        </BreadcrumbItem>
                    ))}
                </Breadcrumbs>
            )}
        </div>
    );
};

export default PageHeader;
